<template>
  <div class="kv-ve-spacer" :class="{ 'is-selected': selected }">
    <div class="kv-ve-spacer__inner" :style="{ height: heightPx }"></div>
  </div>
</template>

<script>
export default {
  name: "VeSpacerBlock",
  props: {
    block: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  computed: {
    heightPx() {
      const n = Number(this.block?.settings?.height);
      return Number.isFinite(n) ? `${n}px` : "16px";
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-spacer__inner {
  width: 100%;
  background: repeating-linear-gradient(
    90deg,
    rgba(148, 163, 184, 0.15),
    rgba(148, 163, 184, 0.15) 10px,
    rgba(148, 163, 184, 0.05) 10px,
    rgba(148, 163, 184, 0.05) 20px
  );
  border-radius: 8px;
}
</style>


